import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useQuery } from '@tanstack/react-query';
import { CarDealershipSettingQueryKeys } from '../car-dealership-setting.props';
import { carDealershipSettingRequestConfig } from 'request-config/car-dealership-setting/car-dealership-setting.request-config';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { ResponseModel } from 'common/interfaces';
import { QueryHookOptions } from 'hooks/react-query/react-query.props';
import { CarDealershipSettingGetList, CarDealershipSettingGetListResponse } from './get-list.props';
import { AxiosResponse } from 'axios';
import { getDataForTable, setValue } from 'utils/get-response-data';
import { objectUtility } from 'utils/object/object';

export const useCarDealershipSettingGetListQuery = (
  companyIdProps?: string,
  { options }: QueryHookOptions<CarDealershipSettingGetList, ResponseModel<CarDealershipSettingGetListResponse>> = {}
) => {
  const user = useTypedSelector(state => state.app.user);

  const companyId = companyIdProps || user.companyId;

  const { fetch } = useFetch<ResponseModel<CarDealershipSettingGetListResponse>>({
    loadingKey: `carDealershipSettingGetListQuery${companyId}`,
    ...carDealershipSettingRequestConfig.getList(companyId)
  });

  const { data, ...restQueryProps } = useQuery<
    AxiosResponse<ResponseModel<CarDealershipSettingGetListResponse>>,
    unknown,
    CarDealershipSettingGetList
  >({
    queryKey: [CarDealershipSettingQueryKeys.GetList, companyId],
    queryFn: () => fetch(),
    ...options,
    select: ({ data }) => getDataForTable(data.data)
  });

  return {
    carDealershipSettingGetListQuery: data || [],
    ...restQueryProps
  };
};
